const BETA_CHANNEL = "beta";
const QUERY_KEY = "ehubChannel";
const STORAGE_KEY = "ehubChannel";

function readQueryChannel(): string {
  if (typeof window === "undefined") return "";
  try {
    return new URLSearchParams(window.location.search).get(QUERY_KEY) || "";
  } catch {
    return "";
  }
}

/** 打开页时把壳子带上的渠道记下，站内跳转丢掉 query 后仍然有效。 */
function captureBetaChannel(): void {
  if (typeof window === "undefined") return;
  if (readQueryChannel() !== BETA_CHANNEL) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, BETA_CHANNEL);
  } catch {
    /* ignore */
  }
}

captureBetaChannel();

/**
 * 内测版：Electron 在同一站点地址上带 ehubChannel=beta。
 */
export function isBetaChannel(): boolean {
  if (typeof window === "undefined") return false;
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === BETA_CHANNEL) return true;
  } catch {
    /* ignore */
  }
  return readQueryChannel() === BETA_CHANNEL;
}
